var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn std center white graybtn relative",class:{inactive: !_vm.validInput},on:{"click":function($event){return _vm.submit()}}},[_c('span',{staticClass:"relative z4"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }